import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem } from "@chakra-ui/react";

import { DocumentsHeader } from "./doc-list/DocumentsHeader";
import { DesktopDocRow } from "./doc-list/DesktopDocRow";
import { DocDecision, SetDecisions } from "./doc-list/types";
import { LegalOnboardingDocument } from "../schema/handler-functions";

interface Props {
  docs: LegalOnboardingDocument[];
  decisions: Record<number, DocDecision>;
  setDecisions: SetDecisions;
  reviewStarted: boolean;
  isPendingRequest: boolean;
  isApprovedRequest: boolean;
  isPreloadedRequest: boolean;
  isRequiresModifRequest: boolean;
  canWrite: boolean;
  showMustStartReviewToast: () => void;
}

export const DocumentsList = ({
  docs,
  decisions,
  setDecisions,
  reviewStarted,
  isPendingRequest,
  isApprovedRequest,
  isPreloadedRequest,
  isRequiresModifRequest,
  canWrite,
  showMustStartReviewToast,
}: Props) => {
  const desktopGridTemplateColumns = "repeat(4, 1fr)";
  const desktopGridGap = "12px";
  const desktopOuterPaddingX = "24px";
  const desktopInnerPaddingX = "12px";
  const desktopHeaderPaddingY = "14px";
  const desktopRowPaddingY = "14px";

  const showMustStartReviewToastSafe = () => {
    if (isApprovedRequest) return;
    if (isPreloadedRequest) return;
    showMustStartReviewToast();
  };

  return (
    <Flex
      flexDir="column"
      border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      borderRadius="12px"
    >
      <Grid
        display={{ base: "none", md: "grid" }}
        templateColumns={desktopGridTemplateColumns}
        width="100%"
        minW={0}
        alignItems="center"
        columnGap="0px"
        maxH={{ md: "520px", lg: "620px" }}
        overflowY="auto"
      >
        <DocumentsHeader
          outerPaddingX={desktopOuterPaddingX}
          innerPaddingX={desktopInnerPaddingX}
          paddingY={desktopHeaderPaddingY}
          columnGap={desktopGridGap}
        />

        {docs.map((doc, index) => {
          const decision = decisions?.[doc.id] ?? null;
          const showWaitingResend = Boolean(doc?.requiereReenvio);
          const hasFile = Boolean(doc?.urlDescarga) && doc?.urlDescarga !== "-";
          const isOptionalDoc =
            doc?.tipo === "Opcional" ||
            (typeof doc?.obligatorio === "boolean" ? !doc.obligatorio : false);

          const disabledDownload =
            !reviewStarted ||
            isPreloadedRequest ||
            isPendingRequest ||
            !hasFile ||
            doc.estado === "Pendiente de Subida";

          const disabledDecision =
            isApprovedRequest ||
            isPreloadedRequest ||
            isRequiresModifRequest ||
            !reviewStarted ||
            isPendingRequest ||
            (!hasFile && isOptionalDoc) ||
            !canWrite;

          const hasDivider = index < docs.length - 1;

          const showToastForDoc = () => {
            if (!reviewStarted) return showMustStartReviewToastSafe();
          };
          return (
            <Flex as="span" key={doc?.id ?? index} display="contents">
              <DesktopDocRow
                doc={doc}
                decision={decision}
                showWaitingResend={showWaitingResend}
                disabledDownload={disabledDownload}
                disabledDecision={disabledDecision}
                hideDecisionActions={!canWrite}
                showMustStartReviewToast={showToastForDoc}
                setDecisions={setDecisions}
                outerPaddingX={desktopOuterPaddingX}
                innerPaddingX={desktopInnerPaddingX}
                paddingY={desktopRowPaddingY}
                columnGap={desktopGridGap}
              />

              {hasDivider ? (
                <GridItem
                  colSpan={4}
                  borderBottom={`1px solid ${AppColors.WHITE_BORDER_1}`}
                />
              ) : null}
            </Flex>
          );
        })}
      </Grid>
    </Flex>
  );
};
